import SupporterScroll from "./supporter-scroll";
import GetShareStats from "./get-share-stats";
import moment from "moment-timezone";

class ShareBarInfo {
  constructor() {
    this.url = window.location.origin + window.location.pathname;
    const container = ".share-info-bar";
    new GetShareStats(this.url, container);
  }
}

function Countdown() {
  if (typeof gon.campaign !== "undefined") {
    if (moment().isBefore(gon.campaign.start_date)) {
      const startDate = moment
        .tz(gon.campaign.start_date, moment.tz.guess())
        .format("YYYY/MM/DD HH:mm:ss");

      $(".days_left").countdown(startDate, function (event) {
        $(this).html(
          event.strftime(`
          <div class="flex-it space-between">
          <span class='countdown'>
            <span class='number'>%DD</span>
          </span>
          <span class='countdown'>
            <span class='number'>%HH</span>
          </span>
          <span class='countdown'>
            <span class='number'>%MM</span>
          </span>
          <span class='countdown'>
            <span class='number'>%SS</span>
          </span>
          </div>
        `),
        );
      });
    } else if (
      !gon.isOngoing &&
      moment().isBefore(gon.end_date) &&
      moment().isSame(gon.end_date, "day")
    ) {
      const endDate = moment(gon.end_date).format("YYYY/MM/DD HH:mm:ss");

      $(".days_left").countdown(endDate, function (event) {
        $(this).html(
          event.strftime(`
          <div class='countdown'>
            <div class='number'>%HH</div>
          </div>
          <div class='countdown'>
            <div class='number'>%MM</div>
          </div>
          <div class='countdown'>
            <div class='number'>%SS</div>
          </div>
        `),
        );
      });
    } else if (!gon.isOngoing && moment().isAfter(gon.end_date)) {
      $(".days_left").find("span").first().text("0");
    }
  }
}

function ActionBar() {
  let closedBar, donateBar, fixedClass, gapHeight;
  donateBar = $(".donate-bar");
  closedBar = $(".campaign-closed");
  fixedClass = "donate-scrolled";
  gapHeight = 60;
  $(window).scroll(function () {
    if ($(this).scrollTop() > gapHeight) {
      donateBar.addClass("donate-scrolled");
      closedBar.addClass("donate-scrolled");
      return $(".campaign-page").css("margin-top", "60px");
    }
    donateBar.removeClass("donate-scrolled");
    closedBar.removeClass("donate-scrolled");
    return $(".campaign-page").css("margin-top", "0px");
  });
}

export default class CampaignPage {
  constructor() {
    ActionBar();
    new ShareBarInfo();
    Countdown();
  }
}
